import React, { useEffect } from 'react';
import { Modal, Text, Stack, Button, Group, Paper } from '@mantine/core';
import { useCart } from '../../context/CartContext';
import { trackCartOpened } from '../../utils/analytics';
import { t } from '../../utils/uiTranslations';

interface CartModalProps {
  opened: boolean;
  onClose: () => void;
  currentLanguage?: string;
}

export const CartModal: React.FC<CartModalProps> = ({
  opened,
  onClose,
  currentLanguage = 'en',
}) => {
  const { items, updateQuantity, clearCart, menuId } = useCart();

  // Track when cart is opened
  useEffect(() => {
    if (opened && items.length > 0 && menuId) {
      trackCartOpened(items.map(item => ({
        id: item.id,
        name: item.name || (item.props?.translations?.en?.name?.text ?? item.props?.enLocalization?.name ?? 'Unknown Item'),
        price: Number(item.price) || 0,
        quantity: item.quantity,
        category: item.props?.enCategory?.text || item.category
      })), menuId);
    }
  }, [opened, items, menuId]);

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t('cartTitle', currentLanguage)}
      size="lg"
      centered
    >
      <Text size="sm" mb="md">
        {t('cartInstructions', currentLanguage)}
      </Text>
      <Stack>
        {items.length === 0 ? (
          <Text>{t('cartEmpty', currentLanguage)}</Text>
        ) : (
          <>
            {items.map((item) => (
              <Paper key={item.id} p="xs" withBorder>
                <Group justify="space-between" align="center">
                  <div style={{ flex: 1 }}>
                    <Text fw={500}>{item.name}</Text>
                    <Text size="sm" c="dimmed">{(item.props?.translations?.en?.name?.text ?? item.props?.enLocalization?.name ?? item.name)}</Text>
                    {/* <Text size="sm" c="dimmed">{Math.floor(Number(item.price))} 円</Text> */}
                  </div>
                  <Group gap="xs" align="center">
                    <Group gap="xs" align="center">
                      <Button
                        variant="light"
                        size="xs"
                        onClick={() => updateQuantity(item.id, item.quantity - 1)}
                      >
                        -
                      </Button>
                      <Text>{item.quantity}</Text>
                      <Button
                        variant="light"
                        size="xs"
                        onClick={() => updateQuantity(item.id, item.quantity + 1)}
                      >
                        +
                      </Button>
                    </Group>
                  </Group>
                </Group>
              </Paper>
            ))}
            {/* <Divider my="md" /> */}
            {/* <Group justify="space-between">
              <Text fw={500}>Total:</Text>
              <Text fw={500}>{Math.floor(total)} 円</Text>
            </Group> */}
            <Group justify="space-between" mt="md">
              <Button variant="light" color="red" onClick={clearCart}>
                {t('clearOrder', currentLanguage)}
              </Button>
              <Button variant="filled" onClick={onClose}>
                {t('close', currentLanguage)}
              </Button>
            </Group>
          </>
        )}
      </Stack>
    </Modal>
  );
}; 